module.exports = __webpack_public_path__ + "img/image.72907208.svg";